module.exports = __webpack_public_path__ + "static/media/main_app_logo.d062e42e.png";